import React from 'react';
import { Badge, Grid, Card, Box, Popover, Typography, IconButton, styled, useTheme, useMediaQuery } from '@mui/material';
import FolderIcon from '@mui/icons-material/Folder';
import { useIconNavigation } from '../../../core/contexts/NavigationContext';
import { Dashboard } from '../../../core/DashboardApi/api';

export interface SimpleIconTextButtonProps {
  icon: React.ComponentType;
  text: string;
  onClick: () => void;
  badgeContent?: number;
}

export const SimpleIconTextButton: React.FC<SimpleIconTextButtonProps> = ({
  icon: IconComponent,
  text,
  onClick,
  badgeContent,
}) => {

  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const CustomIconButton = styled(IconButton)(({ theme }) => ({
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    minWidth: isMobile ? 80 : 120,
    minHeight: isMobile ? 80 : 100,
    height: "auto",
    padding: theme.spacing(1),
    "& .MuiSvgIcon-root": {
      fontSize: isMobile ? "1.5rem" : "3rem",
    },
  }));
  const IconWithBadge = badgeContent != null
    ? (
      <Badge
        badgeContent={badgeContent}
        color="error"
        overlap="circular"
        anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
      >
        <IconComponent />
      </Badge>
    )
    : <IconComponent />;

  return (
    <CustomIconButton
      color="primary"
      sx={{
        boxShadow: "0px 4px 6px rgba(0, 0, 0, 0.1)",
        border: "1px solid rgba(0, 0, 0, 0.12)",
        "&:hover": { backgroundColor: "rgba(0, 0, 0, 0.04)" },
      }}
      onClick={onClick}
    >
      {IconWithBadge}
      <Typography variant="body1" sx={{ mt: 0.5, fontSize: "0.75rem" }} color="CaptionText">
        {text}
      </Typography>
    </CustomIconButton>

  );
};

const PopoverIconTextButton = ({
  icon: IconComponent,
  text,
  onClick,
  element,
}) => {
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);
  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <>
      <CustomIconButton
        id="icon-button"
        color="primary"
        sx={{
          boxShadow: "0px 4px 6px rgba(0, 0, 0, 0.1)",
          border: "1px solid rgba(0, 0, 0, 0.12)",
          "&:hover": {
            backgroundColor: "rgba(0, 0, 0, 0.04)",
          },
        }}
        onClick={handleClick}
      >
        <IconComponent />
        <Typography
          variant="body1"
          sx={{ mt: 0.5, fontSize: "0.75rem" }}
          color="CaptionText"
        >
          {text}
        </Typography>
      </CustomIconButton>
      <Popover
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        aria-labelledby="icon-button"
      >
        <Box p={2}>{element}</Box>
      </Popover>
    </>
  );
};
export interface IDashboardIconProps {
  dashboard: Dashboard,
}
const DashboardIcons = ({ dashboard }: IDashboardIconProps) => {

  const navigation = useIconNavigation();
  console.log(dashboard)
  return (
    <Grid item xs={12}>
      <Card
        sx={{
          position: "relative",
          p: 1,
          display: "flex",
          flexDirection: "row",
          alignItems: "center",
          gap: 1,
          flexWrap: "wrap",
        }}
      >
        {dashboard?.icons?.map((nav) => (
          <SimpleIconTextButton
            key={nav.navigationMenuItem?.id}
            icon={
              navigation.iconMap[nav.navigationMenuItem?.navigationItem?.reactIcon || "None"]
            }
            text={nav.navigationMenuItem?.name}
            onClick={() => navigation.processNavigation(nav.navigationMenuItem!)}
          />
        ))}
        {dashboard?.iconGroups?.map((group) => (
          <PopoverIconTextButton
            key={group.id}
            icon={FolderIcon}
            text={group.name}
            onClick={() => console.log("Popover")}
            element={
              <Box
                sx={{
                  background: "transparent",
                  position: "relative",
                  p: 1,
                  display: "flex",
                  flexDirection: "row",
                  alignItems: "center",
                  gap: 1,
                }}
              >
                {group.icons.map((nav) => (
                  <SimpleIconTextButton
                    key={nav.navigationMenuItem?.id}
                    icon={
                      navigation.iconMap[nav.navigationMenuItem?.navigationItem?.reactIcon || "None"]
                    }
                    text={nav.navigationMenuItem?.name}
                    onClick={() => navigation.processNavigation(nav.navigationMenuItem!)}
                  />
                ))}
              </Box>
            }
          />
        ))}
      </Card>
    </Grid>

  );
};

export default DashboardIcons;
